function handleCollectionTagFilter() {
    jQuery('.sm--collection-filter').on('change', function () {
        var $el = jQuery(this).children("option:selected");
        window.location.href = $el.data('url');
    });
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function bindCartWaveSignature() {

  var $checkbox = jQuery('#WaveSignature');
  // var $giveaway_checkbox = jQuery('#Giveaway');
  var $order_note = jQuery('#CartNoteDrawer, #CartNote');
  var customerData = window.customerData;

  $order_note.parent().addClass('hide');

  // Initialize checkbox state and cart note on page load
  function initializeWaveSignature() {
    // Check if customer has Waive_Signature tag (from data attribute or customerData)
    var hasTag = false;
    if (window.customerTags && window.customerTags.indexOf('Waive_Signature') !== -1) {
      hasTag = true;
    }
    
    // Check cookie/localStorage
    var cookieValue = getCookie('wave_signature');
    var storageValue = localStorage.getItem('wave_signature');
    var shouldBeChecked = hasTag || cookieValue === 'yes' || storageValue === 'yes';
    
    // Check if cart note already contains the wave signature text
    var currentNote = $order_note.val() || $order_note.text() || '';
    var noteContainsWave = currentNote.indexOf('wave the delivery signature') !== -1 || 
                          currentNote.indexOf('waive the delivery signature') !== -1;
    
    if (shouldBeChecked || noteContainsWave) {
      // Check the checkbox
      $checkbox.prop('checked', true);
      
      // Set the cart note if it's not already set
      if (!noteContainsWave) {
        var noteText = 'I want to wave the delivery signature of my order.';
        if ($order_note.is('textarea')) {
          $order_note.val(noteText);
        } else {
          $order_note.text(noteText);
        }
        
        // Show the note field if it was hidden
        $order_note.parent().removeClass('hide');
        
        // Update cart via API
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: noteText })
        })
        .then(response => response.json())
        .then(data => console.log('Cart note initialized:', data))
        .catch(error => console.error('Error setting cart note:', error));
      }
    }
  }
  
  // Run initialization
  initializeWaveSignature();

  $checkbox.on('change', function () {

    // Get the giveaway checkbox
    // var addition = '';
    // if($giveaway_checkbox.is(":checked")) {
    //     addition = '<br>I want to enroll in the giveaway.';
    // }
    //
    // if(this.checked) {
    //     $order_note.text('I want to wave the delivery signature of my order.' + addition);
    // } else {
    //     $order_note.text(addition);
    // }

    if (this.checked) {
        // Set a cookie
        setCookie('wave_signature', 'yes', 365);
        localStorage.setItem('wave_signature', 'yes');
        
        // Update cart note in UI
        var noteText = 'I want to wave the delivery signature of my order.';
        if ($order_note.is('textarea')) {
          $order_note.val(noteText);
        } else {
          $order_note.text(noteText);
        }
        
        // Show the note field if it was hidden
        $order_note.parent().removeClass('hide');
        
        // Update cart via API
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: noteText })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart note updated:', data);
        })
        .catch(error => {
          console.error('Error updating cart note:', error);
        });
        
        // Call API to add tag
        if (customerData && customerData.id) {
          fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({customer: customerData}),
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('API call failed');
            }
            return response.json();
          })
          .then(data => {
            console.log('Tag updated:', data);
          })
          .catch(error => {
            console.error('Error updating customer tag:', error);
          });
        } else {
          console.warn('Customer data not available for tag update');
        }
    } else {
      setCookie('wave_signature', 'no', 365);
      localStorage.setItem('wave_signature', 'no');
      
      // Clear cart note in UI
      if ($order_note.is('textarea')) {
        $order_note.val('');
      } else {
        $order_note.text('');
      }
      
      // Update cart via API
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: '' })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart note cleared:', data);
      })
      .catch(error => {
        console.error('Error clearing cart note:', error);
      });
      
      // Call API to remove tag
      if (customerData && customerData.id) {
        fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({customer: customerData}),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('API call failed');
          }
          return response.json();
        })
        .then(data => {
          console.log('Tag removed:', data);
        })
        .catch(error => {
          console.error('Error removing customer tag:', error);
        });
      }
    }

  });

}

// Invoking all functions and methods
jQuery(function () {
    
    // Bind collection tag filter
    handleCollectionTagFilter();

    
    function getVariantIdFromElement($el) {
      var attr = $el && $el.attr ? $el.attr('data-variant-id') : null;
      if (attr && /^\d+$/.test(attr)) return parseInt(attr, 10);
      return null;
    }

    function getVariantIdFromLink(href) {
      if (!href || href === '#') return null;
      try {
        var url = new URL(href, window.location.origin);
        var variant = url.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) return parseInt(variant, 10);
      } catch (err) {}
      return null;
    }

    function getProductHandleFromLink(href) {
      if (!href || href === '#') return null;

      // Accept Shopify "resource picker" style URLs too
      var normalized = href;
      if (normalized.indexOf('shopify://products/') === 0) {
        normalized = '/products/' + normalized.split('shopify://products/')[1];
      }

      try {
        var url = new URL(normalized, window.location.origin);
        var parts = url.pathname.split('/').filter(Boolean);
        var productsIndex = parts.indexOf('products');
        if (productsIndex !== -1 && parts[productsIndex + 1]) {
          return parts[productsIndex + 1];
        }
      } catch (err) {}

      return null;
    }

    function getShopRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function addVariantToCart(variantId, quantity) {
      var baseUrl = getShopRoot();
      return fetch(baseUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity || 1
        })
      }).then(function(response) { return response.json(); });
    }

    // 4_in_one sticky bar: add fixed certification variant without affecting other buttons
    $(document).on('click', '.js-add-4in1-course', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      addVariantToCart(44975724691702, 1)
        .then(function(data) {
          if (data && data.status === 422) {
            console.error('Add to cart error:', data);
            alert(data.description || 'Could not add to cart. Please try again.');
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          alert('Could not add to cart. Please try again.');
        });
    });

    // Add the product referenced by the button link (instead of a hardcoded variant)
    $(document).on('click', '.sm--add-course-button-4-in-1', function (e) {
      var $btn = $(this);
      var href = $btn.attr('href');

      var quantity = parseInt($btn.data('quantity'), 10);
      if (!quantity || quantity < 1) quantity = 1;

      // 4_in_one page has "online certification" buttons with href="#"
      // In that case, fall back to adding the fixed certification variant.
      var is4InOneTemplate =
        document.querySelector('.sm--4in1-bottom-line-container') ||
        (window.location && window.location.pathname && window.location.pathname.indexOf('/pages/4-in-1-certification') === 0);
      var isHashLink = !href || href === '#' || (typeof href === 'string' && href.trim() === '#');
      if (is4InOneTemplate && isHashLink) {
        e.preventDefault();
        e.stopImmediatePropagation();

        addVariantToCart(44975724691702, quantity)
          .then(function(data) {
            if (data && data.status === 422) {
              console.error('Add to cart error:', data);
              alert(data.description || 'Could not add to cart. Please try again.');
              return;
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(function(error) {
            console.error('Error adding to cart:', error);
            alert('Could not add to cart. Please try again.');
          });
        return;
      }

      var variantId = getVariantIdFromElement($btn) || getVariantIdFromLink(href);
      var productHandle = variantId ? null : getProductHandleFromLink(href);

      // If we can't resolve a product/variant, let it behave like a normal link.
      if (!variantId && !productHandle) {
        return;
      }

      e.preventDefault();

      // Try to add directly if we have a variant id
      var baseUrl = getShopRoot();
      var resolveVariantPromise = variantId
        ? Promise.resolve(variantId)
        : fetch(baseUrl + 'products/' + productHandle + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(product) {
              if (!product || !product.variants || !product.variants.length) return null;
              var available = product.variants.find(function(v) { return v.available; });
              var picked = available || product.variants[0];
              return picked ? picked.id : null;
            })
            .catch(function() { return null; });

      resolveVariantPromise
        .then(function(resolvedId) {
          if (!resolvedId) {
            // Fallback to navigation if we couldn't resolve a variant.
            if (href) window.location.href = href;
            return null;
          }
          return addVariantToCart(resolvedId, quantity);
        })
        .then(function(data) {
          if (!data) return;
          if (data && data.status === 422) {
            console.error('Add to cart error:', data);
            alert(data.description || 'Could not add to cart. Please try again.');
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          alert('Could not add to cart. Please try again.');
        });
    });

    // Add DreamLights Online Certification (hardcoded variant)
    $(document).on('click', '.sm--add-course-button-dreamlights', function (e) {
      var $btn = $(this);

      var quantity = parseInt($btn.data('quantity'), 10);
      if (!quantity || quantity < 1) quantity = 1;

      e.preventDefault();

      addVariantToCart(49948204269814, quantity)
        .then(function(data) {
          if (data && data.status === 422) {
            console.error('Add to cart error:', data);
            alert(data.description || 'Could not add to cart. Please try again.');
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          alert('Could not add to cart. Please try again.');
        });
    });

    jQuery(window).on('load', function () {
      bindCartWaveSignature();
    });

    document.addEventListener('cart:change', function(evt) {
      let cartTotal = parseFloat(evt.detail.subtotal) / 100;
      jQuery('.cart-progress-item').each(function(index, progressItem) {
        let threshold = parseFloat(jQuery(progressItem).data('threshold'));
        if(cartTotal >= threshold) jQuery(progressItem).addClass('progress-reached');
        else jQuery(progressItem).removeClass('progress-reached');
      });
    });
});